import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import NoTimeSlots from './NoTimeSlots.js';
import { Variant } from './types.js';

const NoTimeSlotsContainer = ({ variant , noAvailabilityUntilDate , nextAvailableDate , action ,  })=>{
    const { getLabel , getFormattedLabel , dateTime  } = useIntl();
    const { formatLongDate  } = dateTime;
    const labels = React.useMemo(()=>{
        switch(variant){
            case Variant.time:
                return {
                    lines: [
                        getLabel('appointments.component.timeslots.noTimeAvailable'),
                        getLabel('appointments.component.timeslots.nextAvailableDate'), 
                    ],
                    action: nextAvailableDate ? formatLongDate(nextAvailableDate) : ''
                };
            case Variant.date:
                return {
                    lines: [
                        getLabel('appointments.component.timeslots.noSlotsAvailable'),
                        getLabel('appointments.component.timeslots.nextAvailableDate'), 
                    ],
                    action: nextAvailableDate ? formatLongDate(nextAvailableDate) : ''
                };
            case Variant.closedDate:
                return {
                    lines: [
                        getLabel('appointments.component.timeslots.storeClosed'),
                        getLabel('appointments.component.timeslots.nextAvailableDate'), 
                    ],
                    action: nextAvailableDate ? formatLongDate(nextAvailableDate) : ''
                };
            case Variant.week:
                return {
                    lines: [
                        getFormattedLabel('appointments.component.timeslots.noAvailabilityUntilDate', {
                            labelData: swcHelpers.objectSpread({}, noAvailabilityUntilDate ? {
                                date: formatLongDate(noAvailabilityUntilDate)
                            } : {})
                        }), 
                    ],
                    action: getLabel('appointments.component.timeslots.nextWeeks')
                };
            case Variant.closedWeek:
                return {
                    lines: [
                        getFormattedLabel('appointments.component.timeslots.storeClosed', {
                            labelData: swcHelpers.objectSpread({}, noAvailabilityUntilDate ? {
                                date: formatLongDate(noAvailabilityUntilDate)
                            } : {})
                        }), 
                    ],
                    action: getLabel('appointments.component.timeslots.nextWeeks')
                };
            case Variant.error:
                return {
                    lines: [
                        getLabel('appointments.component.timeslots.error')
                    ],
                    action: getLabel('appointments.component.timeslots.retry')
                };
            case Variant.none:
            default:
                return {
                    lines: []
                };
        }
    }, [
        getLabel,
        getFormattedLabel,
        formatLongDate,
        variant,
        noAvailabilityUntilDate,
        nextAvailableDate, 
    ]);
    return /*#__PURE__*/ React.createElement(NoTimeSlots, {
        variant: variant,
        labels: labels,
        action: action
    });
};

export { NoTimeSlotsContainer as default };
//# sourceMappingURL=NoTimeSlotsContainer.js.map
